import React from 'react';
import { ReactComponent as CheckIcon } from '@/img/bookings/check.svg';

const Stepper = ({
	steps = [],
	current = 1,
}) => {
	return (
		<div className="stepper" role="list" aria-label="progress">
			{steps.map((label, i) => {
				const index = i + 1;
				const state = index < current ? 'done' : index === current ? 'active' : 'todo';
				const isDone = state === 'done';
				const isActive = state === 'active';

				return (
					<React.Fragment key={`${label}-${i}`}>
						<div className={`stepper__step stepper__step--${state}`} role="listitem">
							<div className="stepper__circle" aria-hidden="true">
								{isDone ? <CheckIcon className="stepper__check" /> : index}
							</div>
							<div className="stepper__label">{label}</div>
						</div>

						{index !== steps.length && (
							<span
								className={`stepper__line stepper__line--${index < current ? 'done' : 'todo'}`}
								aria-hidden="true"
							/>
						)}
					</React.Fragment>
				);
			})}
		</div>
	);
};

export default Stepper;
